export default "__VITE_ASSET__CAxgyzF$__";